module.exports = __webpack_public_path__ + "static/media/IconPhoneBottledGoose.22367283.png";